/*365플러스 컬러별 색상 확인 슬라이드*/
const slideContainer = document.getElementById('slideContainer');
const progressBar = document.getElementById('progressBar');
const selectedColorDisplay = document.getElementById('selectedColor');

// ✅ background-image URL 방식으로 수정
const colorMap = {
  beige: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-beige.jpg)',
    name: ' ベージュ'
  },
  gray: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-gray.jpg)',
    name: ' グレー'
  },
  mint: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-mint.jpg)',
    name: ' ミント'
  },
  khaki: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-khaki.jpg)',
    name: ' カーキ'
  },
  bk: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-black.jpg)',
    name: ' ブラック'
  },
  zebra: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/zebra_2c186bb6-337e-4276-900f-32f1196e5ce5.jpg)',
    name: ' ゼブラ'
  },
  bleo: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/brown-leopard_d51a4ff1-4eeb-41ce-8ebe-fc425132fab7.jpg)',
    name: ' ブラウンレオパード'
  },
  gleo: {
    bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/gray-leopard_dabcaa90-d935-4442-89f1-781b4c9ec972.jpg)',
    name: ' グレー レオパード'
  }
};

let swiper;

function loadSlides(color) {
  slideContainer.innerHTML = '';
  for (let i = 1; i <= 6; i++) {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    const padded = String(i).padStart(2, '0');
    slide.innerHTML = `<img src="https://gooseket.com/web/upload/product_detail/365plus/colorchip/365plus_${color}${padded}.jpg" alt="${color}-${i}">`;
    slideContainer.appendChild(slide);
  }
  if (swiper) swiper.destroy(true, true);
  swiper = new Swiper('.colorSwiper', {
    loop: false,
    slidesPerView: 1.5,
    spaceBetween: 10,
    grabCursor: true,
    allowTouchMove: true,
    on: {
      slideChange: () => {
        const total = swiper.slides.length;
        const progress = ((swiper.realIndex + 1) / total) * 100;
        progressBar.style.width = progress + '%';
      }
    }
  });
  progressBar.style.width = '16.6%';
}

document.querySelectorAll('.color-circle').forEach(el => {
  const color = el.getAttribute('data-color');
  const colorInfo = colorMap[color];
  if (colorInfo) {
    el.style.backgroundImage = colorInfo.bg;
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center';
  }

  el.addEventListener('click', () => {
    document.querySelector('.color-circle.active')?.classList.remove('active');
    el.classList.add('active');

    loadSlides(color);

    selectedColorDisplay.innerHTML = `
      <div class="chip" style="background-image:${colorInfo.bg}; background-size:cover;"></div>
      <span>${colorInfo.name}</span>
    `;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  loadSlides('bk');
});


/*구석구석 섬세한 */

new Swiper('.structure-swiper', {
  slidesPerView: 1.5,
  spaceBetween: 20,
  grabCursor: true,
  loop: false,
  centeredSlides: false,
  slidesOffsetAfter: 40,
});

/*어디든 착_핸디백/힙색/유모차가방/무한한활용도_365플러스*/


document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.customSingleSlideSwiper', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    grabCursor: true,
    on: {
      init: function () {
        updateProgressBar(this);
      },
      slideChange: function () {
        updateProgressBar(this);
      }
    }
  });

  function updateProgressBar(swiperInstance) {
    const totalSlides = swiperInstance.slides.length;
    const percent = ((swiperInstance.activeIndex + 1) / totalSlides) * 100;

    // ✅ ID 정확히 맞춰서 수정
    const bar = document.getElementById('customProgressBar');
    if (bar) bar.style.width = percent + '%';
  }

  // ✅ 초기 바 상태 설정 (init에서 이미 호출되므로 생략 가능)
  // updateProgressBar(swiper);
});


/*어디든 착_핸디백/힙색/유모차가방/무한한활용도_슬링백*/


  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.customSingleSlideSwiper2', {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 10,
      grabCursor: true,
      on: {
        init: function () {
          updateProgressBar(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        }
      }
    });

    function updateProgressBar(swiperInstance) {
      const totalSlides = swiperInstance.slides.length;
      const percent = ((swiperInstance.activeIndex + 1) / totalSlides) * 100;

      const bar = document.getElementById('progressBarSliderOnly');
      if (bar) {
        bar.style.width = percent + '%';
      } else {
        console.warn('❗ progressBarSliderOnly not found');
      }
    }
  });





/*슬링백상단누끼슬라이드*/

 const chips = document.querySelectorAll('.color-circle');
    const image = document.getElementById('mainImage');
    const chipDisplay = document.querySelector('#selectedColor .chip');
    const nameDisplay = document.querySelector('#selectedColor span');

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');

        const imgSrc = chip.getAttribute('data-img');
        const colorHex = chip.getAttribute('data-hex');
        const colorName = chip.getAttribute('data-name');

        image.src = imgSrc;
        chipDisplay.style.background = colorHex;
        nameDisplay.textContent = colorName;
      });
    });


/*슬링백 누끼 컬러칩 탭메뉴_365슬링백*/

const chipsTop = document.querySelectorAll('.color-circle-top');
const imageTop = document.getElementById('mainImageTop');
const chipDisplayTop = document.querySelector('#selectedColorTop .chip-top');
const nameDisplayTop = document.querySelector('#selectedColorTop span');

chipsTop.forEach(chip => {
  chip.addEventListener('click', () => {
    chipsTop.forEach(c => c.classList.remove('active'));
    chip.classList.add('active');

    const imgSrc = chip.getAttribute('data-img');
    const colorHex = chip.getAttribute('data-hex');
    const colorName = chip.getAttribute('data-name');

    imageTop.src = imgSrc;
    chipDisplayTop.style.background = colorHex;
    nameDisplayTop.textContent = colorName;
  });
});

/*컬러별 색상을 확인하세요 슬라이드_착용샷_365힙시트 상세*/
const swipers = [];

function initColorSlider365() {
  const container = document;

  container.querySelectorAll('.swiper.colorSwiper').forEach(swiperEl => {
    const color = swiperEl.dataset.color;
    const progressBar = container.querySelector(`.progress-bar-container[data-color="${color}"] .progress-bar-fill`);

    const instance = new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 10,
      centeredSlides: false,
      on: {
        slideChange() {
          const total = this.slides.length - 1;
          const current = this.activeIndex;
          const percent = (current / total) * 100;
          if (progressBar) progressBar.style.width = `${percent}%`;
        },
        init() {
          this.emit('slideChange');
        }
      }
    });

    swipers.push({ color, instance });
  });

  const chips = container.querySelectorAll('.color-chip');
  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      const selected = chip.dataset.color;

      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');

      container.querySelectorAll('.swiper.colorSwiper').forEach(s => {
        s.style.display = s.dataset.color === selected ? 'block' : 'none';
      });
      container.querySelectorAll('.progress-bar-container').forEach(pb => {
        pb.style.display = pb.dataset.color === selected ? 'block' : 'none';
      });

      const target = swipers.find(s => s.color === selected);
      if (target) {
        target.instance.update();
        target.instance.slideTo(0);
      }
    });
  });

  const firstChip = container.querySelector('.color-chip[data-color]');
  if (firstChip) firstChip.click();
}

document.addEventListener('DOMContentLoaded', () => {
  initColorSlider365();
});


/*아코디언 부딪힘 이슈해결*/


/*비디오태그 재생
   document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      document.querySelectorAll('video').forEach(video => {
        if (video.offsetParent !== null) {
          video.play().catch(() => {});
        }
      });
    }, 300);
  });*/

  
  /*비디오태그 재생 수정코드 */
  document.addEventListener('DOMContentLoaded', () => {
  const vids = [...document.querySelectorAll('video')];
  vids.forEach(v => { v.muted = true; v.setAttribute('playsinline',''); });

  const START = 0.4, STOP = 0.15;
  const state = new WeakMap();

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      const v = e.target;
      const r = e.intersectionRatio;
      const s = state.get(v) || {p:false};
      if (!s.p && r >= START) { v.play().catch(()=>{}); state.set(v,{p:true}); }
      else if (s.p && r <= STOP) { try{v.pause();}catch{} state.set(v,{p:false}); }
    });
  }, {threshold:[0,STOP,START,1]});

  vids.forEach(v => {
    io.observe(v);
    const tryPlay = ()=>v.play().catch(()=>{});
    v.addEventListener('loadeddata', tryPlay, {once:true});
    v.addEventListener('canplay',     tryPlay, {once:true});
    v.addEventListener('ended', ()=>{ v.currentTime=0; v.play().catch(()=>{}); });
  });

  document.addEventListener('visibilitychange', ()=>{
    if (!document.hidden)
      vids.forEach(v=>{
        const r=v.getBoundingClientRect();
        const vis=Math.max(0,Math.min(1,(Math.min(r.bottom,innerHeight)-Math.max(r.top,0))/r.height));
        if (vis>=START && v.paused) v.play().catch(()=>{});
      });
  });
});
/*비디오태그 재생 수정코드 끝*/

(function () {
  // 1) 후보만 선택: data-autoplay 있거나 hero 영역의 video만
  const vids = Array.from(document.querySelectorAll('video'))
    .filter(v => v.hasAttribute('data-autoplay') || v.closest('.hero, .pdp-hero, .section-video'));

  // 2) 초기 세팅: 모바일 자동재생 요건 + 가벼운 프리로드
  vids.forEach(v => {
    v.setAttribute('muted', '');        // iOS 자동재생 필수
    v.muted = true;
    v.setAttribute('playsinline', '');  // iOS 전체화면 전환 방지
    v.setAttribute('preload', 'metadata');
    // poster가 있다면 유지. 없으면 필요 시 설정
    // v.setAttribute('poster', v.dataset.poster || '');
  });

  // 3) 화면 안에 들어올 때만 play, 나가면 pause
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const v = entry.target;

      // 숨김/디스플레이 none 등은 스킵
      const style = getComputedStyle(v);
      const isHidden = style.display === 'none' || style.visibility === 'hidden' || v.offsetParent === null;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.25 && !isHidden) {
        // iOS에서 드물게 발생하는 play Promise reject는 무음 처리
        v.play().catch(() => {/* noop */});
      } else {
        // 리소스/배터리 절약
        try { v.pause(); } catch(e) {}
      }
    });
  }, { threshold: 0.25 });

  vids.forEach(v => io.observe(v));

  // 4) SPA식 네비/섹션 리렌더 대비: visibilitychange에도 제어
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      vids.forEach(v => { try { v.pause(); } catch(e) {} });
    } else {
      vids.forEach(v => {
        const rect = v.getBoundingClientRect();
        const inView = rect.top < window.innerHeight * 0.75 && rect.bottom > window.innerHeight * 0.25;
        if (inView) v.play().catch(() => {});
      });
    }
  });
})();


/*컬러칩 슬라이드 재수정*/
document.addEventListener('DOMContentLoaded', () => {
    const swipers = [];
    const container = document.querySelector('.color_slide_365-wrap');

    if (!container) return;

    container.querySelectorAll('.color_slide_365-swiper').forEach(swiperEl => {
      const color = swiperEl.dataset.color;
      const progressEl = swiperEl.nextElementSibling.querySelector('.color_slide_365-progress-fill');

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1.5,
        spaceBetween: 10,
        centeredSlides: false,
        on: {
          slideChange() {
            const total = this.slides.length - 1;
            const current = this.activeIndex;
            const percent = (current / total) * 100;
            if (progressEl) progressEl.style.width = `${percent}%`;
          },
          init() {
            this.emit('slideChange');
          }
        }
      });
      swipers.push({ color, swiper });
    });

    const chips = container.querySelectorAll('.color_slide_365-chip');
    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        const selected = chip.dataset.color;
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');

        container.querySelectorAll('.color_slide_365-swiper').forEach(s => {
          s.style.display = s.dataset.color === selected ? 'block' : 'none';
        });

        container.querySelectorAll('.color_slide_365-progress').forEach(p => {
          p.style.display = p.previousElementSibling.dataset.color === selected ? 'block' : 'none';
        });

        const target = swipers.find(s => s.color === selected);
        if (target) {
          target.swiper.update();
          target.swiper.slideTo(0);
        }

        container.querySelector('.color_slide_365-label').textContent = selected;
      });
    });

    const firstChip = container.querySelector('.color_slide_365-chip');
    if (firstChip) firstChip.click();
  });
/*컬러칩 슬라이드 재수정 끝*/

/*아코디언 수정*/
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((acc, i) => {
    acc.addEventListener("click", function () {
      this.classList.toggle("active");
      const panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  /*0929 겨울워머 상세 슬라이드 추가 */
  /* ✅ Intro 슬라이드 */
document.addEventListener('DOMContentLoaded', function () {
  const introSwiper = new Swiper('.introSwiper', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 10,
    grabCursor: true,
    on: {
      init: function () {
        updateIntroProgress(this);
      },
      slideChange: function () {
        updateIntroProgress(this);
      }
    }
  });

  function updateIntroProgress(swiperInstance) {
    const totalSlides = swiperInstance.slides.length;
    const percent = ((swiperInstance.activeIndex + 1) / totalSlides) * 100;
    const bar = document.getElementById('introProgressBar');
    if (bar) bar.style.width = percent + '%';
  }
});
/* AIR + 슬링백 상세*/
document.addEventListener('DOMContentLoaded', function () {

var airHeroEl2 = document.querySelector('.airHeroSwiper');

if (airHeroEl2 && typeof Swiper !== 'undefined') {
new Swiper(airHeroEl2, {
slidesPerView: 1,
loop: true,
speed: 600,
pagination: {
el: '.airHeroPagination',
clickable: true
}
});
}

var airUseEl = document.querySelector('.airUseSwiper');

if (airUseEl && typeof Swiper !== 'undefined') {
new Swiper(airUseEl, {
slidesPerView: 1.25,
spaceBetween: 10
});
}

});


/* AIR + 슬링백 NEW 상세*/
/* Gooseket AIR+ product detail interactions (Shopify theme asset). */
(() => {
  'use strict';

  const SWIPER_URL = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-element-bundle.min.js';
  const SWIPER_SCRIPT_ID = 'gooseket-airplus-swiper-element';

  function loadSwiperElement() {
    if (customElements.get('swiper-container')) return Promise.resolve();

    let script = document.getElementById(SWIPER_SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = SWIPER_SCRIPT_ID;
      script.src = SWIPER_URL;
      script.async = true;
      document.head.appendChild(script);
    }

    return new Promise((resolve, reject) => {
      if (customElements.get('swiper-container')) return resolve();
      script.addEventListener('load', () => customElements.whenDefined('swiper-container').then(resolve), { once: true });
      script.addEventListener('error', () => reject(new Error('Swiper Element could not load')), { once: true });
    });
  }

  function initializeSliders() {
    document.querySelectorAll('.newMySwiper5, .newMySwiper3').forEach((el) => {
      if (el.swiper || el.dataset.gooseketInitialized === 'true') return;
      if (typeof el.initialize !== 'function') return;

      if (el.classList.contains('newMySwiper5')) {
        Object.assign(el, {
          slidesPerView: 1,
          loop: true,
          pagination: { clickable: true },
          observer: true,
          observeParents: true
        });
      } else {
        Object.assign(el, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          pagination: { type: 'progressbar' },
          observer: true,
          observeParents: true
        });
      }

      el.initialize();
      el.dataset.gooseketInitialized = 'true';
    });
  }

  function setupColors() {
    document.querySelectorAll('.colorOptWrapAll').forEach((group) => {
      if (group.dataset.gooseketColorsReady) return;
      const section = group.closest('.prdDetailWrap');
      if (!section) return;

      const buttons = [...section.querySelectorAll('.colorOptDetail:not(.colorOptDetail2)')];
      const labels = [...group.querySelectorAll('.colorOptTxtWrap > .colorOptTxt')];
      const panels = [...group.querySelectorAll('li.colorOptWrap')];
      if (!buttons.length || buttons.length !== panels.length) return;
      group.dataset.gooseketColorsReady = 'true';

      function select(index) {
        buttons.forEach((button, i) => {
          button.classList.toggle('focused', i === index);
          button.setAttribute('role', 'button');
          button.setAttribute('tabindex', '0');
          button.setAttribute('aria-label', `${labels[i]?.textContent.trim() || `색상 ${i + 1}`} 사진 보기`);
          button.setAttribute('aria-pressed', String(i === index));
        });
        labels.forEach((label, i) => {
          label.style.display = i === index ? 'block' : 'none';
        });
        panels.forEach((panel, i) => {
          panel.style.display = i === index ? 'block' : 'none';
        });
        requestAnimationFrame(() => {
          panels[index]?.querySelector('swiper-container')?.swiper?.update();
        });
      }

      buttons.forEach((button, i) => {
        button.addEventListener('click', () => select(i));
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          select(i);
        });
      });
      select(0);
    });
  }

  function setupAccordions() {
    document.querySelectorAll('#extras_wrap > .extras').forEach((section) => {
      if (section.dataset.gooseketAccordionReady) return;
      const header = section.querySelector(':scope > .extrasTop');
      const bodies = [...section.querySelectorAll(':scope > .extrasBottom')];
      if (!header || !bodies.length) return;
      section.dataset.gooseketAccordionReady = 'true';
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');

      function setOpen(open) {
        bodies.forEach((body) => {
          body.style.display = open ? 'block' : 'none';
        });
        header.setAttribute('aria-expanded', String(open));
      }

      header.addEventListener('click', () => {
        setOpen(header.getAttribute('aria-expanded') !== 'true');
      });
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        header.click();
      });
      setOpen(true);
    });
  }

  function start() {
    if (!document.querySelector('#prdDetailWrapAll_new')) return;
    setupColors();
    setupAccordions();
    loadSwiperElement()
      .then(initializeSliders)
      .catch((error) => console.error('[Gooseket AIR+]', error));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();


/*FAQ*/
/* AIR+ FAQ: FAQ 제목 → 질문 → 답변 */
(function () {
  function initAirFaq() {
    var faq = document.querySelector('#prdDetailWrapAll_new .jp-air-faq');
    if (!faq || faq.dataset.faqReady === 'true') return;
    faq.dataset.faqReady = 'true';

    var topButton = faq.querySelector('.jp-air-faq-top');
    var list = faq.querySelector('.jp-air-faq-list');

    topButton.addEventListener('click', function () {
      var willOpen = topButton.getAttribute('aria-expanded') !== 'true';
      topButton.setAttribute('aria-expanded', String(willOpen));
      list.hidden = !willOpen;
    });

    faq.addEventListener('click', function (event) {
      var question = event.target.closest('.jp-air-faq-question');
      if (!question || !faq.contains(question)) return;

      var willOpen = question.getAttribute('aria-expanded') !== 'true';
      var answer = document.getElementById(question.getAttribute('aria-controls'));
      if (!answer) return;

      faq.querySelectorAll('.jp-air-faq-question[aria-expanded="true"]').forEach(function (openQuestion) {
        openQuestion.setAttribute('aria-expanded', 'false');
        var openAnswer = document.getElementById(openQuestion.getAttribute('aria-controls'));
        if (openAnswer) openAnswer.hidden = true;
      });

      question.setAttribute('aria-expanded', String(willOpen));
      answer.hidden = !willOpen;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAirFaq);
  } else {
    initAirFaq();
  }
})();